<template>
    <v-dialog v-model="dialog" max-width="400">
        <template v-slot:activator="{ on }">
            <div v-if="trigger===undefined">
                <v-btn v-if="fab" fab bottom right dark fixed color="indigo"  v-on="on">
                    <v-icon>{{icons.upload}}</v-icon>
                </v-btn>
                <v-btn
                        v-else
                        color="awesome"
                        dark
                        v-on="on"
                >
                    <v-icon>{{icons.upload}}</v-icon>
                </v-btn>
            </div>
        </template>
        <v-card>
            <v-card-title>
                File Uploader
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog=false"><v-icon>{{icons.close}}</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row v-if="previews[0]">
                    <v-col>
                        <vue-cropper
                                v-if="!cropImg"
                                ref="cropper"
                                :src="previews[0]"
                                :aspectRatio="aspectratio"
                        >
                        </vue-cropper>
                        <v-img v-else :src="cropImg" />
                        <v-btn text color="awesome"
                               dark
                               :disabled="progress[0]!==0"
                               v-if="(previews[0]) && !cropImg"
                               @click="cropImage()">Crop</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <form ref="form" >
                            <v-file-input
                               hint="Select Files"
                               outlined
                               accept="image/*"
                               :disabled="disabled"
                               chips
                               show-size
                               :multiple="!limitone"
                               ref="files"
                               @change="readfile($event)"
                               @click:clear="clearAll()"
                            />
                        </form>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="awesome"
                       dark
                       large
                       text
                       @click="Upload()"
                       v-if="(previews[0]) && cropImg"
                       :loading="loading"
                >
                    save
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';
    import {
      mapState,
      mapActions
    } from 'vuex'
    import AWS from 'aws-sdk'
  import Evaporate from "evaporate";
    export default {
      props: ['fab','limitone','trigger'],
      components: { VueCropper },
      data: () => ({
        aspectratio: 1,
        dialog: false,
        disabled: false,
        progress: [],
        filestoupload: undefined,
        previews: [],
        uploading:false,
        showupload:false,
        emitkeys: [],
        cropImg:false,
        finished:false,
        loading:false
      }),
      computed:{
        ...mapState(['idpool','userpool','org','icons']),
      },
      watch:{
        trigger(n){
          if(n)this.dialog=n
        },
        dialog(n,o){
          console.log('N',n,o,this.trigger)
          if(!n)this.$emit('closing',false)
          if(!n && this.filestoupload){
            this.$refs.files.reset()
            this.clearAll()
          }
        },
        finished(n,o){
          if(n){
            this.disabled=false
            this.showupload=false
            this.$emit('newfiles',this.emitkeys)
            this.emitkeys = []
            this.dialog = false
          }
        }
      },
      methods: {
        ...mapActions(['cognito']),
        readfile(event) {
          this.previews = []
          this.filestoupload = event.length===0?undefined:event
          this.showupload = event.length===0?false:true
          let em = this;
          event.forEach((file,i) => {
            em.previewFile(file,i)
          })
        },
        previewFile(file,i) {
          const reader = new FileReader();
          let em = this;
          reader.addEventListener("load", function () {
            em.previews.push(reader.result)
            em.progress[i] = 0
            console.log(file.size/1000000)
            // if(file.size/1000000 > 1){
            //   em.aspectratio = .5
            // }
            // if(file.size/1000000 > 2){
            //   em.aspectratio = .25
            // }
          }, false);
          reader.readAsDataURL(file);
        },
        async Upload() {
          var em = this;
          //var file = new File([em.gensave], 'tmp.jpg', {type: "image/jpeg"});
          var file = this.dataURItoBlob(this.cropImg);
          var filePromises = [], allCompleted;
          let session = await this.$store.dispatch('cognito/fetchSession');
          let imagepath = 'https://images.athleteforlife.org/'
          this.loading=true
          Evaporate.create({
            signerUrl: em.$store.state.url + 'api/mobile/signv4_authv2',
            signHeaders: {
              'Authorization': 'Bearer '+ session.accessToken.jwtToken,
              'Pool': this.userpool
            },
            aws_key: 'AKIAIERQHVC6LFNJNTVA',
            awsRegion: 'us-west-2',
            bucket: 'a4luserimages',
            awsSignatureVersion: '4',
            computeContentMd5: true,
            cryptoMd5Method: function (data) {
              return AWS.util.crypto.md5(data, 'base64');
            },
            cryptoHexEncodedHash256: function (data) {
              return AWS.util.crypto.sha256(data, 'hex');
            }
          })
            .then(function (evaporate) {
                em.finished=false
                //var file = em.image;//  em.$refs.file.files[0];

                //foreach file, evaporate
                for (var i = 0; i < 1; i++) {
                  var ct = i;
                  var type = 'mime/jpeg';
                  var size = '400X400';
                  var ext = 'jpg';
                  var filename = session.accessToken.payload.sub+'/'+new Date().getTime();
                  em.emitkeys.push(imagepath+filename+'.jpg')
                  var promise = evaporate.add({
                    name: filename + '.' + ext,
                    file: file,
                    xAmzHeadersAtInitiate: {
                      'x-amz-acl': 'public-read',
                      'content-type': type,
                      'x-amz-storage-class': 'STANDARD'
                    },
                    progress: function (progress) {
                      em.progress[i] = progress * 100;
                    }
                  })
                    .then(function (awsKey) {
                      console.log('ALL COMPLETE ', awsKey, 'complete!');
                    });
                  filePromises.push(promise);
                }
                return allCompleted = Promise.all(filePromises)
                  .then(function () {
                    em.finished=true
                    em.loading=false
                    return console.log('All files were uploaded successfully.');

                  }, function (reason) {
                    console.log('All files were not uploaded successfully:', reason);
                  });

              },
              function (reason) {
                console.log('Evaporate failed to initialize: ', reason)
              }
            );
        },
        clearAll(){
          this.previews = []
          this.filestoupload = undefined
          this.cropImg = undefined
        },
        async cropImage() {
          // get image data for post processing, e.g. upload or setting image src
          let tmpi = await this.$refs.cropper.getCroppedCanvas()
          console.log(tmpi, tmpi.width,tmpi.height)
          var rcv = document.createElement("canvas")
          rcv.height = 200;
          rcv.width = 200;
          var rsz = rcv.getContext('2d');
          rsz.drawImage(tmpi, 0, 0, 200, 200);
          this.cropImg = await rcv.toDataURL();
          this.Upload()
        },
        dataURItoBlob(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for(var i = 0; i < binary.length; i++) {
              array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
          }
      }
    }
</script>

<style>
    .ol{
        color: black;
        -webkit-text-fill-color: white; /* Will override color (regardless of order) */
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: black;
    }
</style>
